import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChefHat, Bath, Home as HomeIcon, Hammer, ArrowRight } from "lucide-react";
import { remodel, img, company } from "../mock";
import Seo from "../components/Seo";

const iconMap = { ChefHat, Bath, Home: HomeIcon, Hammer };

const Remodel = () => {
  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Remodel & Home Additions"
        description="Monarch Homes of Brevard brings custom-home craftsmanship to kitchen remodels, bathroom renovations, home additions and whole-home renovations across Brevard County."
        keywords="home remodeling Brevard County, kitchen remodel Melbourne FL, bathroom renovation Space Coast, home additions Florida"
        path="/remodel"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.kitchen2})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Remodel</div>
          <h1>Remodel By Monarch Homes</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container mh-split">
          <div className="mh-reveal">
            <img src={img.living2} alt="Remodeled interior" />
          </div>
          <div className="mh-reveal">
            <div className="mh-eyebrow">Renovations &amp; Additions</div>
            <h2>{remodel.heading}</h2>
            <p>{remodel.intro}</p>
            <div style={{ marginTop: 26 }}>
              <Link to="/contact" className="mh-cta-btn">Start Your Remodel <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mh-section cream tight">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">What We Do</div>
            <h2>Remodeling Services</h2>
            <div className="mh-divider" />
          </div>
          <div className="mh-highlights">
            {remodel.services.map((s, i) => {
              const Ic = iconMap[s.icon];
              return (
                <div key={i} className="mh-hi-card mh-reveal" style={{ transitionDelay: `${i * 70}ms` }}>
                  <div className="mh-hi-icon"><Ic size={28} /></div>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Our Work</div>
            <h2>Craftsmanship In Every Detail</h2>
            <div className="mh-divider" />
          </div>
          <div className="mh-grid-3">
            {remodel.gallery.map((src, i) => (
              <div key={i} className="mh-gal-item mh-remodel-item mh-reveal">
                <img src={src} alt="Monarch remodel project" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mh-cta-band">
        <div className="mh-container mh-reveal">
          <h2>Let&rsquo;s Transform Your Home</h2>
          <p>From a single room to a whole-home renovation, our team brings custom-home quality to every remodel.</p>
          <div className="mh-hero-actions">
            <Link to="/contact" className="mh-cta-btn">Request A Consultation <ArrowRight size={16} /></Link>
            <a href={company.phoneHref} className="mh-btn-ghost-light">Call {company.phone}</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Remodel;
